import { useEffect, useState } from "react";
import { PdfGenerator } from "../../../../../../../../../components/PdfGenerator";
import PdfViewDrawer from "../../../../../../../../../components/PdfViewDrawer";
import { useLoadingContext } from "../../../../../../../../../context/LoadingProvider";
import useDisclosure from "../../../../../../../../../hooks/use-disclosure";
import { useGetPatientScreenersWithAssessment } from "../../../../../../../../../queries/patient-chart/forms/use-get-patient-screeners-with-assessment";
import { getXtenantId } from "../../../../../../../../../utils/utils";
import AssessmentReportTemplate from "../../../../../../../../../template/AssessmentReportTemplate";

interface ViewAssessmentDrawerProps {
  pdfRef: React.RefObject<{ generatePdf: () => void }>;
  screenerType: string;
  appointmentId: string;
  onClose?: () => void;
}

const ViewAssessmentDrawer = ({
  pdfRef,
  screenerType,
  appointmentId,
  onClose,
}: ViewAssessmentDrawerProps) => {
  const { setIsLoading } = useLoadingContext();
  const [previewFile, setPreviewFile] = useState<string>("");
  const printViewDisclosure = useDisclosure(false, {
    onClose: () => onClose?.(),
  });

  const { data: assessmentResponse } = useGetPatientScreenersWithAssessment({
    appointmentUuid: appointmentId,
    screenerType,
    xTENANTID: getXtenantId() ?? "",
  });

  const responseData = (assessmentResponse as any)?.data?.data;
  const assessmentData = responseData
    ? (Object.values(responseData)?.[0] as React.ComponentProps<
        typeof AssessmentReportTemplate
      >["data"])
    : undefined;

  useEffect(() => {
    if (assessmentData) {
      pdfRef.current?.generatePdf();
    }
  }, [assessmentData]);

  return (
    <>
      <PdfGenerator
        ref={pdfRef}
        onSave={(blob) => {
          setIsLoading(false);
          if (!blob) return;
          const url = globalThis.URL.createObjectURL(blob);
          setPreviewFile(url);
          printViewDisclosure.open();
        }}
      >
        <AssessmentReportTemplate
          data={assessmentData}
          screenerType={screenerType}
        />
      </PdfGenerator>

      <PdfViewDrawer
        w="65vw"
        file={previewFile}
        disclosureHost={printViewDisclosure}
        title="Screening Assessment Report"
      />
    </>
  );
};

export default ViewAssessmentDrawer;
